

export default class JavascriptHelpers
{

    //https://stackoverflow.com/questions/15329503/conversion-of-a-hash-function-from-c-sharp-to-javascript-has-issues-with-bitwise
    static getStableHash(s, hashlength) {
      var hash = 0;
      var bytes = Uint8Array.from(s);
      //var bytes = stringToBytes(s);   // this function just grabs a byte array for the given input string
      for (var i = 0; i < bytes.length; i++) {
        hash += bytes[i];
        hash += hash << 10;
        hash ^= hash >> 6;
      }
      // final avalanche
      hash += hash << 3;
      hash ^= hash >> 11;
      hash += hash << 15;
  
      //return Math.round(hash % hashlength);
      return (hash >>> 0) % hashlength;
    }


    //https://gist.github.com/jlevy/c246006675becc446360a798e2b2d781 alternative hash function
    static simpleHash(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
      }
      // Convert to 32bit unsigned integer in base 36 and pad with "0" to ensure length is 7.
      return (hash >>> 0).toString(36).padStart(7, '0');
    };

    static toCamel(o) {
        var newO, origKey, newKey, value;
        if (o instanceof Array) {
          return o.map(function (value) {
            if (typeof value === "object") {
              value = JavascriptHelpers.toCamel(value);
            }
            return value;
          });
        } else {
          newO = {};
          for (origKey in o) {
            if (o.hasOwnProperty(origKey)) {
              newKey = (
                origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey
              ).toString();
              value = o[origKey];
              if (
                value instanceof Array ||
                (value !== null && value.constructor === Object)
              ) {
                value = JavascriptHelpers.toCamel(value);
              }
              newO[newKey] = value;
            }
          }
        }
        return newO;
      }


}